import { ProgramNames, PROVIDER_TYPES } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ConsentText } from '../messages'
import { ProgramConfig } from '../types'

export const ALCOHOL_USE_DISORDER_THERAPY_PROGRAM = {
  programName: ProgramNames.AlcoholUseDisorderTherapy,
  blendedCareProgramId: 'edcea864-b6eb-4d16-8c4c-ce748c18025e',
  customerPropertyId: ProgramCustomerPropertyId.alcoholUseDisorderTherapy,

  associatedProviderTypes: [PROVIDER_TYPES.LYRATHERAPIST.lyraType],
  associatedProviderModalities: ['alcoholUseDisorderTherapy'],

  canRescheduleAppointment: true,
  selfPayEligible: true,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.ALCOHOL_USE_DISORDER],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.blendedCare,
        offering: PROGRAM_TAXONOMY.offering.alcoholUseDisorder,
      },
    ],
    isFullTreatmentOption: true,
  },

  consents: [
    {
      consentText: ConsentText.alcoholUseDisorderConsent,
      consentUrl: 'https://www.lyrahealth.com/aud-agreement',
      showConsentIf: () => true,
    },
  ],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },

  noteContentMetadataName: {
    INITIAL_NOTE: 'audSudExpansionInitialNote',
    SESSION_NOTE: 'audSudExpansionSessionNote',
    GENERAL_NOTE: 'audSudExpansionGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
    OLD_INITIAL_NOTE: 'audInitialNote',
    OLD_SESSION_NOTE: 'audSessionNote',
    OLD_GENERAL_NOTE: 'audGeneralNote',
  },
} satisfies ProgramConfig
